<template>
  <div class="respreview">
    <Header :userinfo="userInfo"></Header>
      <div class="container fix">
        <div class="navigation">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/microClass/list/'+resourceTypeId+'/2/40'}">微课学习</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="opts-info">
          <p>
            <span v-if="source !== ''">资源来源：{{source}} <i class="division-line"></i></span>
            <!-- 作者：{{author || "佚名"}}
            <i class="division-line"></i>
            <template v-if="userInfo.bookInfo.versionId === 6 && tags.length > 0">
              标签：{{tags.join(';')}}
              <i class="division-line"></i>
            </template> -->
            更新时间：{{timeFormatter(updateTime)}}
          </p>
        </div>
        <div class="content" ref="preview">
          <div class="source-container">
            <div v-if="previewType === 1">
              <video-player id="resourceVideo" class="video-player-box" ref="videoPlayer" :options="playerOptions" :playsinline="true"></video-player>
              <a class="download" :href="resourceUrl">下载视频</a>
              <div class="attachment-container" v-if="attachs.length > 0">
                  <h3 class="attachment-title">附件列表</h3>
                  <ul class="attachment-list ui-scroll">
                    <li class="attachment-item" v-for="(item, index) in attachs" :key="index">{{item.name}} <a :href="item.fileUrl" target="_blank">下载</a></li>
                  </ul>
              </div>
            </div>
            <div class="img-box ui-scroll" v-else-if="previewType === 2 || previewType === 4">
              <img width="650" v-for="(item, index) in pictrues" :src="item" :key="index">
            </div>
            <div v-else class="resource-info fix">
              <div class="info-icon">
                <img :src="defaultImg[resourceTypeId + '-' + categoryId]" alt>
              </div>
              <div class="info-text">
                <p class="info-line">内容介绍：{{resourceDesc}}</p>
                <p class="info-line">作者：{{author || '佚名'}}</p>
                <p class="info-line">更新时间：{{timeFormatter(updateTime)}}</p>
                <p v-if="tags.length>0" class="info-line">标签：{{tags.join(';')}}</p>
                <p class="info-line">
                  <a :href="resourceUrl" target="_blank">立即下载</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="sidebar">
          <TeachingAssistantInfo></TeachingAssistantInfo>
        </div>
      </div>
      <Footer ref="footer"></Footer>
    </div>
</template>
<script>
import api from '../../utils/api'
import moment from 'moment'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import TeachingAssistantInfo from '@/components/TeachingAssistantInfo'
import { Loading } from 'element-ui'
export default {
  components: {
    TeachingAssistantInfo,
    Header,
    Footer
  },
  data () {
    return {
      userInfo: {},
      previewHeight: 530,
      previewType: 2, // 资源展示方式 1=mp4，2=图片 ， 3=下载, 4=教学资源包合并的内容（图片+下载）
      author: '',
      attachments: [],
      attachs: [], // 附件列表
      catalogueName: '',
      categoryId: '',
      pickCode: '',
      pictrues: [],
      resourceDesc: '',
      resourceId: '',
      resourceUrl: '',
      resourceTypeId: 0, // 资源类型
      resourceExtTypeId: 0,
      tags: [],
      source: '',
      thumbImg: '',
      title: '',
      updateTime: 0,
      versionId: 0,
      versionName: '',
      playerOptions: {
        // videojs options
        muted: false,
        language: 'cn',
        width: 668,
        // height: 376,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'video/mp4',
            src: ''
          }
        ],
        poster: ''
      },
      defaultImg: {
        '3-2': require('@/assets/icon-teach-2.png'),
        '0-2': require('@/assets/icon-ppt-2.png'),
        '2-2': require('@/assets/icon-cartoon-2.png'),
        '1-1': require('@/assets/icon-lesson-2.png'),
        '2-1': require('@/assets/icon-textbook-2.png'),
        '4-2': require('@/assets/icon-draw-2.png'),
        '5-2': require('@/assets/icon-song-2.png'),
        '6-2': require('@/assets/icon-movie-2.png'),
        '7-2': require('@/assets/icon-english-2.png')
      }
    }
  },
  created () {
    let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
    this.userInfo = userInfo
    this.bookId = this.$route.query.bookId || undefined
    this.initResourceInfo()
  },
  mounted () {
    this.resizePreview()
  },
  methods: {
    initResourceInfo () {
      this.resourceId = this.$route.query.resourceId
      this.resourceTypeId = this.$route.query.resourceTypeId
      this.resourceExtTypeId = this.$route.query.resourceExtTypeId
      this.catalogueId = this.$route.query.catalogueId
      this.categoryId = this.$route.query.categoryId
      let loadingInstance = Loading.service()
      api.post(
        'GetTeachResourceInfoRequest',
        {
          resourceId: this.resourceId,
          categoryId: this.categoryId,
          catalogueId: this.catalogueId,
          resourceExtTypeId: this.resourceExtTypeId,
          resourceTypeId: this.resourceTypeId,
          bookId: this.bookId || this.userInfo.bookInfo.bookId
        },
        res => {
          let data = res.body
          this.attachments = data.attachments
          this.attachs = data.attachs
          this.author = data.author
          this.catalogueName = data.catalogueName
          this.categoryId = data.categoryId
          this.pictrues = data.pictrues
          this.previewType = data.previewType
          this.pickCode = data.pickCode
          this.resourceDesc = data.resourceDesc
          this.resourceId = data.resourceId
          this.resourceUrl = data.resourceUrl
          this.source = data.source
          this.tags = data.tags
          this.thumbImg = data.thumbImg
          this.title = data.title
          this.updateTime = data.updateTime
          this.versionId = data.versionId
          this.versionName = data.versionName
          this.playerOptions.poster = data.thumbImg
          this.playerOptions.sources.push({
            src: data.resourceUrl,
            type: 'video/mp4'
          })
          // this.videoSources[0].src = data.resourceUrl
          // this.$set(this.videoOptions, "poster", data.thumbImg)
          // this.videoSources.push({
          //     src: data.resourceUrl,
          //     type: "video/mp4"
          // })
          this.resizePreview()
          loadingInstance.close()
        }
      )
    },
    timeFormatter (time) {
      return moment.unix(time).format('YYYY年MM月DD日')
    },
    resizePreview () {
      let preview = this.$refs.preview
      let footer = this.$refs.footer
      this.previewHeight = footer.$el.offsetTop - preview.offsetTop - 20
    }
  }
}
</script>

<style scoped>
.respreview {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}
.container {
  flex: 1;
  margin: 0 auto;
  width: 960px;
  background-color: #f5f5f5;
}
.navigation {
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 14px;
}
.navigation .breadcrumb {
  float: left;
  color: #aaa;
}
.navigation .book-select {
  float: right;
  color: #888;
}
.navigation .book-select span {
  margin-left: 10px;
  color: #ffae44;
}

.opts-info p {
  margin: 0 0 20px 0;
  padding: 0;
  font-size: 12px;
  color: #888;
}

.content {
  float: left;
  width: 710px;
  height: 606px;
  background: #fff;
}

.content .info-icon {
  float: left;
  margin-right: 18px;
  width: 130px;
  height: 166px;
  border-radius: 8px;
}

.content .info-icon img {
  width: 130px;
  height: 166px;
  border-radius: 8px;
}

.content .info-text {
  float: left;
  width: 517px;
  font-size: 14px;
  color: #333;
}

.content .info-text p {
  margin-top: 10px;
}

.content .info-text a {
  color: #FE793A;
  cursor: pointer;
  text-decoration: none;
}

.content .source-container {
  height: 470px;
  padding: 20px 20px 0 20px;
  box-sizing: border-box;
}
.content .source-container .img-box {
  height: 430px;
}

.content .source-container img {
  display: block;
}

.content .attachment-container{
  height: 140px;
  border-top: 1px #ddd solid;
  padding: 20px;
  margin-top: 20px;
  box-sizing: border-box;
}

.content .attachment-container .attachment-title{
  position: relative;
  font-size: 14px;
  color: #333;
  margin: 0;
  padding: 0;
  padding-left: 12px;
}

.content .attachment-container .attachment-title::before{
  content: "";
  position: absolute;
  top: 4px;
  left: 0;
  background-color: #FE793A;
  width: 3px;
  height: 12px;
}

.attachment-list {
  height: 80px;
  margin: 0;
  padding-left: 20px;
}

.content .attachment-container .attachment-item {
  font-size: 12px;
  margin: 8px 0;
}

.content .attachment-container .attachment-item a {
  color: #FE793A;
  cursor: pointer;
  text-decoration: none;
  margin-left: 10px;
}

.content .attachment-container .no-attach {
  color: #666;
  font-size: 14px;
  padding-left: 15px;
}

.sidebar {
  float: left;
  margin-left: 30px;
}

.division-line {
  display: inline-block;
  margin: 0 12px;
  height: 14px;
  width: 2px;
  background-color: #ccc;
  vertical-align: -2px;
}

.download {
  display: inline-block;
  color: #FE793A;
  margin-top: 20px;
  text-decoration: none;
}

</style>
<style>
#resourceVideo .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -0.75em;
  margin-left: -1.5em;
}
</style>
